import LogoutButton from "@/components/auth/logout-button";
import { getConfigValue } from "@rumble-it/common-lib/src/config";
import { useEffect } from "react";
import { useCurrentUser } from "../../../lib/hooks/useCurrentUser";
import { useNavigate } from "react-router-dom";
import { PendingUserForm } from "./components/PendingUserForm";
import { ConfigProvider } from "antd";
import { adminTheme } from "../../../theme/adminTheme";

export const PendingUser = () => {
  const currentUser = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) {
      return;
    }
    if (
      currentUser.role.dealershipRequired &&
      currentUser.role.dealership !== null &&
      !currentUser.role.isPending
    ) {
      navigate("/");
    }
  }, [currentUser, navigate]);
  return (
    <ConfigProvider theme={adminTheme}>
      <div className="flex flex-col items-center justify-between gap-4 px-6 py-8 h-screen overflow-x-hidden">
        <div className="flex flex-col items-center gap-12 w-full">
          <img
            alt="RumbleDirect Logo"
            src={`${getConfigValue("cdnUrl")}/static/assets/logos/logo-rumble.svg`}
            className="max-w-48 w-auto h-auto"
          />
          <div className="max-w-lg w-full">
            <PendingUserForm />
          </div>
        </div>

        <div className="bottom-0 mb-8 flex justify-center">
          <LogoutButton />
        </div>
      </div>
    </ConfigProvider>
  );
};
